import * as types from './item.types';
import * as constants from './item.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const itemReducer = generateResourceReducer<types.IItem>({
  STORE: constants.STORE_ITEM,
  CLEAR: constants.CLEAR_ITEM,
});
